/**
 * 设备上，某个技能购买的二维码，扫描之后的落地页
 */

import React, { useState, ChangeEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { service } from 'service';
import { useRequest, useBrowserTitle, useWxConfig, useLocationQuery } from 'hook/index';
import { BlockLoading, BlockEmpty } from 'component/BlockLoading/BlockLoading';
import { isWechatWebview } from 'util/index';
import WechatPayLanding from './WechatPayLanding';
import AlipayLanding from './AlipayLanding';
import styles from './PayLanding.module.scss';

interface BackendData {
    // 技能标志
    type: string;
    // 技能中文名
    appNameCh?: string;
    // 包几个月
    months: number;
    // 价格
    price: number;
}

export default function PayLanding() {
    useBrowserTitle('技能包月');
    useWxConfig();
    const [isSubmit, setIsSubmit] = useState(false);
    const searchConf = useLocationQuery();
    const history = useHistory();
    const {
        loading,
        data,
    } = useRequest<BackendData>({
        url: `/wechat/prices`,
        method: 'POST',
        data: {
            token: searchConf.str,
        },
        defaultData: { type: '', appNameCh: '', months: 1, price: 0, },
        defaultIsLoading: true,
    });
    if (isWechatWebview()) {
        // 微信内，跳转到通用会员购买页
        history.replace({
            pathname: '/mp/user/pay',
            search: window.location.search,
        });
        return null;
    }
    // function paySingleSkill() {
    //     service.post('/wx/wxPaySkill', {
    //         serviceType: data.type,
    //         months: data.months || 1,
    //     })
    //         .then(function(out){
    //             setIsSubmit(false);
    //             if (out.status === 200 && out.data) {
    //                 if (out.data.status === 0) {
    //                     const data = out.data.data;
    //                     // alert(JSON.stringify(data));
    //                     WeixinJSBridge.invoke(
    //                         'getBrandWCPayRequest', data,
    //                         function(res: any) {
    //                             if (res.err_msg === "get_brand_wcpay_request:ok" ){
    //                                 // 使用以上方式判断前端返回,微信团队郑重提示：
    //                                 //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
    //                                 alert('恭喜，支付成功！');
    //                                 window.wx && window.wx.closeWindow();
    //                             } else {
    //                                 console.log(JSON.stringify(res));
    //                                 alert('支付失败');
    //                             }
    //                         });
    //                 } else {
    //                     throw new Error(out.data.message);
    //                 }
    //             } else {
    //                 throw new Error(`网络异常，请稍后再试`);
    //             }
    //         })
    //         .catch(function(err: Error){
    //             setIsSubmit(false);
    //             alert(err.message);
    //         });
    // }
    // 跳转到会员购买页面
    function buyVip() {
        // window.location.href = '/mp/user/pay';
    }
    let content = null;
    if (loading) {
        content = (<BlockLoading/>);
    } else if(!data.appNameCh) {
        content = (
            <div className={styles.errorMsg}>出错了，请稍后再试</div>
        );
    } else {
        content = (<AlipayLanding />);
        // if (isWechatWebview()) {
        //     content = (<WechatPayLanding {...data} />);
        // } else {
        //     content = (<AlipayLanding {...data} />);
        // }
    }
    return (
        <div className={styles.page}>
            {content}
        </div>
    );
}
